import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import { fetchSitePartnersAction } from '../../../../../../store/siteDucks/sitePartners';
import ConsentForm from './ConsentForm';
import s from './MarketingPreferencesForm.module.scss';

export default function MarketingPreferencesForm({ consentForms = [] }) {
  const dispatch = useDispatch();
  const {
    tenantConfig: { name: tenantName },
  } = useRootSelector(selectPageConfig);

  useEffect(() => {
    dispatch(fetchSitePartnersAction());
  }, [dispatch]);

  const privacyPolicyAnchor = (
    <a
      href="https://www.informa.com/privacy-policy/"
      target="_blank"
      rel="noreferrer"
    >
      Privacy Notice
    </a>
  );

  return (
    <div className={s.wrapper}>
      <p className={s.accessText}>
        {tenantName} will use the data collected here to provide access to the
        requested content.
      </p>
      <div className={s.consentForms}>
        {consentForms.map((consentForm, index) => (
          <ConsentForm key={index} data={consentForm} />
        ))}
      </div>
      <p className={s.optOutText}>
        You can opt out of any time clicking unsubscribe or contacting us or the
        sender. For further details, see our {privacyPolicyAnchor}.
      </p>
    </div>
  );
}
